import { render, staticRenderFns } from "./ConfigBulkSendSettings.vue?vue&type=template&id=53fd27ca&scoped=true"
import script from "./ConfigBulkSendSettings.vue?vue&type=script&lang=js"
export * from "./ConfigBulkSendSettings.vue?vue&type=script&lang=js"
import style0 from "./ConfigBulkSendSettings.vue?vue&type=style&index=0&id=53fd27ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fd27ca",
  null
  
)

export default component.exports